import { render, staticRenderFns } from "./annualAccounts-detail.vue?vue&type=template&id=3c5894fe"
import script from "./annualAccounts-detail.vue?vue&type=script&lang=js"
export * from "./annualAccounts-detail.vue?vue&type=script&lang=js"
import style0 from "./annualAccounts-detail.vue?vue&type=style&index=0&id=3c5894fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports